// Vizualizace donačítání legacy agend: spinner, tečky, patní řádek a horní proužek.
// „Jediný čestný signál“ — žádné skeletony, žádný počet (nevíme, kam položky přibudou).

import { useTranslation } from 'react-i18next';

import type { MenuLoadViz } from './menuTypes';

/** Točící se kolečko (12 px). */
export function MenuSpinner() {
  return (
    <span className="border-phx-border-2 border-t-phx-primary inline-block h-3 w-3 shrink-0 animate-[phm-spin_0.7s_linear_infinite] rounded-full border-[1.8px]" />
  );
}

/** Tři pulzující tečky. */
export function MenuDots() {
  return (
    <span className="gap-phx-1_5 inline-flex items-center">
      {[0, 0.15, 0.3].map((delay, i) => (
        <span
          key={i}
          className="bg-phx-primary block h-1 w-1 animate-[phm-pulse_1s_infinite] rounded-full opacity-40"
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
    </span>
  );
}

/** Patní řádek uvnitř otevřeného menu. */
export function LoadFooter({ viz, ready }: { readonly viz: MenuLoadViz; readonly ready: boolean }) {
  const { t } = useTranslation('sharedUi');
  if (ready || viz === 'none') return null;
  return (
    <div className="border-phx-border text-phx-text-muted mt-phx-1_5 text-phx-xs flex items-center gap-2 border-t border-dashed px-[9px] pt-2 pb-1.5">
      {viz === 'dots' ? <MenuDots /> : <MenuSpinner />}
      <span>{t('mainMenu.loading')}</span>
    </div>
  );
}

/** Tenký indeterminate proužek nad obsahem menu. */
export function LoadBar({ viz, ready }: { readonly viz: MenuLoadViz; readonly ready: boolean }) {
  if (ready || viz !== 'bar') return null;
  return (
    <div className="bg-phx-surface-2 rounded-phx-xs relative my-px h-0.5 overflow-hidden">
      <span className="bg-phx-primary rounded-phx-xs absolute inset-y-0 left-0 w-[38%] animate-[phm-slide_1.2s_var(--phx-ease-out)_infinite]" />
    </div>
  );
}
